<template>
  <div class="">
  
<div v-if="EstadoBotonUsuarios" class="text-left d-flex align-items-center mx-5 mt-3">
      <i @click="EstadoDeBotonUsuarios(false)" class="bi bi-house fs-1 text-primary"></i>
    </div>
    <div v-if="permisoVisualizador != 11" class=" position-relative">
  
      <img src="../../assets/TopasCentro/Topas.png" alt="" width="70" height="70" />
      <img src="../../assets/imagenesPlataform/logoGrupoWhite2.png" alt="" width="120" height="40" class="me-3"
        style="position: absolute; top: 0; right: 0" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "SolimanologTopasVisual",

  data() {
    return {
      permisoVisualizador: ""
    };
  },

  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

  },

    computed: {
          ...mapGetters('acciones',["EstadoBotonUsuarios"]),

    },

  methods: {
    ...mapActions('acciones', ['EstadoDeBotonUsuarios'])
  },
};
</script>

<style lang="scss" scoped></style>